import React from 'react';
import '../Styles/Footer.css';

// LinkedIn Icon
const LinkedInIcon = () => (
  <svg
    className="social-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="#ffffff"
    viewBox="0 0 24 24"
  >
    <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4V24h-4V8zm7.5 0h3.8v2.2h.1c.5-.9 1.9-2.2 4.1-2.2 4.4 0 5.2 2.9 5.2 6.7V24h-4v-7.5c0-1.8 0-4-2.4-4s-2.8 1.9-2.8 3.9V24h-4V8z"/>
  </svg>
);

// WhatsApp Icon
const WhatsAppIcon = () => (
  <svg
    className="social-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="#ffffff"
    viewBox="0 0 24 24"
  >
    <path d="M12.04 2a9.9 9.9 0 0 0-8.4 15.65L2 22l4.35-1.64A9.9 9.9 0 1 0 12.04 2zm5.8 14.4c-.24.67-1.39 1.32-1.93 1.38-.5.05-1.13.08-1.82-.12-.42-.13-.96-.31-1.66-.62a10.46 10.46 0 0 1-3.8-3.35c-.4-.55-.88-1.3-.88-2.1s.55-1.5.77-1.73c.2-.22.44-.27.6-.27h.43c.14 0 .32-.05.5.38.18.43.6 1.47.65 1.58s.08.22.02.35-.1.22-.2.34c-.1.12-.22.26-.31.35-.1.1-.2.2-.1.38.1.19.45.74.96 1.2.66.59 1.2.77 1.4.86.2.1.32.08.44-.05.13-.14.5-.58.63-.78.13-.2.27-.17.46-.1s1.2.57 1.4.67c.2.1.33.16.38.25.05.1.05.72-.18 1.4z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">

        {/* Single Row Social Section */}
        <div className="social-inline">
          <div className="social-group">
            <span className="social-label">Shanti</span>
            <a
              href="https://www.linkedin.com/company/shantielectricals"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Shanti Electricals on LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </div>

          <div className="social-divider" />

          <div className="social-group">
            <span className="social-label">Stahlform</span>
            <a
              href="https://www.linkedin.com/company/stahllform-technik-private-limited"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Stahlform Technik on LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </div>

          <div className="social-divider" />

          <div className="social-group">
            <a href="https://wa.me/7200319392" target="_blank" rel="noopener noreferrer">
              <WhatsAppIcon />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="copyright">
          2025 © Shanti Group. All Rights Reserved.
        </div>

      </div>
    </footer>
  );
};

export default Footer;
